<template>
  <ValidateAll ref="header">
    <v-row v-if="!terkunci && !loading">
      <v-col cols="6">
        <div class="headline mt-2">{{title()}}</div>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-btn
          color="warning"
          outlined
          large
          class="mr-2"
          @click="clearAllCache"
          v-if="cacheRincianExists || cachePajakExists"
        >
          <span class="hidden-xs-only">Bersihkan Cache</span>
          <v-icon :right="!$vuetify.breakpoint.xsOnly">mdi-delete-outline</v-icon>
        </v-btn>
        <v-btn color="primary" large @click="save" :loading="saving">
          <span class="hidden-xs-only">Simpan</span>
          <v-icon :right="!$vuetify.breakpoint.xsOnly">mdi-content-save-outline</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row :dense="$vuetify.breakpoint.xsOnly">
      <!-- Header -->
      <v-col cols="12" md="3">
        <v-card class="card-summary card-summary--transaksi">
          <v-card-subtitle class="pb-0 d-flex">
            <div class="overline">
              <v-icon small left class="mt-n1">mdi mdi-bag-personal</v-icon>Sekolah
            </div>
            <v-btn
              icon
              color="primary"
              v-if="!(isSekolahEmpty || isEditingSekolah) && !terkunci && !saving && !$acl.check('isSekolah')"
              @click="isEditingSekolah = true"
            >
              <v-icon small>mdi-cog</v-icon>
            </v-btn>
          </v-card-subtitle>
          <v-skeleton-loader :loading="loading" type="list-item-two-line">
            <v-list-item two-line>
              <Validate
                class="w-100"
                name="Sekolah"
                rules="fully_required"
                #default="{ errors }"
                v-if="isEditingSekolah"
              >
                <v-autocomplete
                  :error-messages="errors"
                  class="mb-1 mt-1"
                  v-model="header.Sekolah"
                  :loading="list.isSekolahLoading"
                  :items="list.sekolah.data"
                  name="Sekolah"
                  placeholder="Pilih Sekolah"
                  item-text="Nama"
                  item-value="IDSekolah"
                  dense
                  hide-no-data
                  return-object
                >
                  <!-- button slot -->
                  <template v-slot:append-outer>
                    <v-btn
                      icon
                      :disabled="isSekolahEmpty"
                      :color="isSekolahEmpty ? 'disabled' : 'success'"
                      @click="isEditingSekolah = !isEditingSekolah"
                    >
                      <v-icon>mdi-check-outline</v-icon>
                    </v-btn>
                  </template>
                  <!-- selected slot -->
                  <template v-slot:selection="data">
                    <v-list-item-title>
                      {{data.item.Nama}}
                      &mdash;
                      <span
                        class="text--secondary"
                      >{{data.item.Kode}}</span>
                    </v-list-item-title>
                  </template>
                  <!-- list item slot -->
                  <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'">
                      <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                      <v-list-item-content>
                        <v-list-item-title class="py-0">
                          {{data.item.Nama}}
                          &mdash;
                          <span
                            class="text--secondary"
                          >{{data.item.Kode}}</span>
                        </v-list-item-title>
                        <v-list-item-subtitle>{{ data.item.Alamat}} {{ data.item.Lokasi}} {{data.item.Provinsi}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-autocomplete>
              </Validate>
              <v-list-item-content v-if="!isSekolahEmpty && !isEditingSekolah">
                <v-list-item-title class="title">{{header.Sekolah.Nama}}</v-list-item-title>
                <v-list-item-subtitle>
                  <span class="text--primary">{{header.Sekolah.Kode}}</span>
                  &mdash;
                  {{header.Sekolah.Alamat}} {{header.Sekolah.Lokasi}} {{header.Sekolah.Provinsi}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-skeleton-loader>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card class="card-summary card-summary--transaksi">
          <v-card-subtitle class="pb-0 d-flex">
            <div class="overline">
              <v-icon small left class="mt-n1">mdi mdi-run</v-icon>Kegiatan
            </div>
            <v-btn
              icon
              color="primary"
              v-if="!(isKegiatanEmpty || isEditingKegiatan || isEdit) && !terkunci && !saving"
              @click="editKegiatan"
            >
              <v-icon small>mdi-cog</v-icon>
            </v-btn>
          </v-card-subtitle>
          <v-skeleton-loader :loading="loading" type="list-item-two-line">
            <v-list-item v-if="isEditingKegiatan">
              <v-autocomplete
                class="mb-1 mt-1"
                v-model="header.Program"
                :loading="list.isProgramLoading"
                :items="list.program.data"
                name="Program"
                :placeholder="isSekolahEmpty? 'Pilih Sekolah Terlebih Dahulu':'Pencarian Program'"
                :disabled="isSekolahEmpty"
                item-text="Nama"
                item-value="IDProgram"
                dense
                hide-details
                hide-no-data
                return-object
              >
                <!-- selected slot -->
                <template v-slot:selection="data">
                  <v-list-item-title>
                    {{data.item.Nama}}
                    &mdash;
                    <span
                      class="text--secondary"
                    >{{data.item.Kode}}</span>
                  </v-list-item-title>
                </template>
                <!-- list item slot -->
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content v-text="data.item"></v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{data.item.Nama}}
                        &mdash;
                        <span
                          class="text--secondary"
                        >{{data.item.Kode}}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-list-item>
            <v-list-item :class="{'mt-n2':isEditingKegiatan}">
              <v-autocomplete
                v-if="isEditingKegiatan"
                class="mb-1 mt-1"
                v-model="header.Kegiatan"
                :loading="list.isKegiatanLoading"
                :items="listKegiatan"
                name="Kegiatan"
                :placeholder="isProgramEmpty? 'Pilih Program Terlebih Dahulu':'Pencarian Kegiatan'"
                :disabled="isProgramEmpty"
                item-text="Nama"
                item-value="IDKegiatan"
                dense
                hide-details
                hide-no-data
                return-object
              >
                <!-- button slot -->
                <template v-slot:append-outer>
                  <v-btn
                    icon
                    :disabled="isKegiatanEmpty"
                    :color="isKegiatanEmpty ? 'disabled' : 'success'"
                    @click="isEditingKegiatan = !isEditingKegiatan"
                  >
                    <v-icon>mdi-check-outline</v-icon>
                  </v-btn>
                </template>
                <!-- selected slot -->
                <template v-slot:selection="data">
                  <v-list-item-title>
                    {{data.item.Nama}}
                    &mdash;
                    <span
                      class="text--secondary"
                    >{{data.item.Kode}}</span>
                  </v-list-item-title>
                </template>
                <!-- list item slot -->
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content v-text="data.item"></v-list-item-content>
                  </template>
                  <template v-else>
                    <v-list-item-content>
                      <v-list-item-title>
                        {{data.item.Nama}}
                        &mdash;
                        <span
                          class="text--secondary"
                        >{{data.item.Kode}}</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
              <v-list-item-content v-if="!isKegiatanEmpty && !isEditingKegiatan">
                <v-list-item-title class="title">{{header.Kegiatan.Nama}}</v-list-item-title>
                <v-list-item-subtitle>
                  <span class="text--primary">{{header.Kegiatan.Kode}}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-skeleton-loader>
        </v-card>
      </v-col>
      <v-col cols="6" md="3">
        <v-card class="card-summary card-summary--transaksi">
          <v-card-subtitle class="pb-0 d-flex">
            <div class="overline">
              <v-icon small left class="mt-n1">mdi mdi-wallet</v-icon>Penerimaan
            </div>
          </v-card-subtitle>
          <v-skeleton-loader :loading="loading" type="list-item-two-line">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title class="title">{{totalPenerimaan | currency}}</v-list-item-title>
                <v-list-item-subtitle v-if="lastUpdatedDatePenerimaan">
                  <span class="hidden-sm-and-down">
                    Terakhir berubah
                    &mdash;
                  </span>
                  {{lastUpdatedDatePenerimaan | dateRelative}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-skeleton-loader>
        </v-card>
      </v-col>
      <v-col cols="6" md="3">
        <v-card class="card-summary card-summary--transaksi">
          <v-card-subtitle class="pb-0 d-flex">
            <div class="overline">
              <v-icon small left class="mt-n1">mdi mdi-cart</v-icon>Belanja
            </div>
          </v-card-subtitle>
          <v-skeleton-loader :loading="loading" type="list-item-two-line">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title class="title">{{totalBelanja | currency}}</v-list-item-title>
                <v-list-item-subtitle v-if="lastUpdatedDateBelanja">
                  <span class="hidden-sm-and-down">
                    Terakhir berubah
                    &mdash;
                  </span>
                  {{lastUpdatedDateBelanja | dateRelative}}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-skeleton-loader>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-subtitle class="pb-0">
            <div class="overline">
              <v-icon small left class="mt-n1">mdi mdi-calendar-check-outline</v-icon>Transaksi
            </div>
          </v-card-subtitle>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-skeleton-loader :loading="loading" type="list-item-two-line,list-item-two-line">
                  <v-text-field
                    name="Nomor"
                    label="Nomor"
                    placeholder="Nomor akan muncul setelah transaksi disimpan"
                    v-model="header.Nomor"
                    hide-details="auto"
                    disabled
                  ></v-text-field>

                  <br />

                  <v-dialog
                    ref="dialog"
                    v-model="modalDatepicker"
                    :return-value.sync="header.Tanggal"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="formattedDate"
                        label="Tanggal Pelaporan"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :disabled="terkunci || saving"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="header.Tanggal" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="modalDatepicker = false">Batal</v-btn>
                      <v-btn text color="primary" @click="$refs.dialog.save(header.Tanggal)">Pilih</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-skeleton-loader>
              </v-col>
              <v-divider vertical class="hidden-xs-only" />
              <v-col class="mr-n1 mt-6 mt-sm-0 mt-md-0 mt-lg-0 mt-xl-0" cols="12" md="6">
                <v-skeleton-loader :loading="loading" type="list-item-three-line">
                  <v-textarea
                    no-resize
                    :height="$vuetify.breakpoint.xsOnly ? '20px':'102px'"
                    :rows="$vuetify.breakpoint.xsOnly ? 3:5"
                    name="Keterangan"
                    label="Keterangan"
                    placeholder="Keterangan"
                    v-model="header.Keterangan"
                    hide-details="auto"
                    :readonly="terkunci || saving"
                  ></v-textarea>
                </v-skeleton-loader>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Details -->
      <v-col cols="12">
        <v-card>
          <v-card-subtitle class="pb-0 text-right">
            <div class="overline">
              <v-icon small left class="mt-n1">mdi mdi-table</v-icon>Rincian
            </div>
          </v-card-subtitle>
          <v-card-text>
            <v-skeleton-loader :loading="loading" type="table">
              <v-tabs class="mt-n8" background-color="transparent">
                <v-tab :href="`#tab-transaksi`">Transaksi</v-tab>
                <v-tab :href="`#tab-pajak`">Pajak</v-tab>
                <v-tab-item value="tab-transaksi">
                  <rincian-transaksi
                    v-model="details"
                    :disabled="terkunci || isSekolahEmpty || isKegiatanEmpty || saving"
                  ></rincian-transaksi>
                </v-tab-item>
                <v-tab-item value="tab-pajak">
                  <rincian-pajak
                    v-model="pajak"
                    :disabled="terkunci || isSekolahEmpty || isKegiatanEmpty || saving"
                  ></rincian-pajak>
                </v-tab-item>
              </v-tabs>
            </v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </ValidateAll>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import _ from "lodash";

export default {
  components: {
    RincianTransaksi: () =>
      import(
        /* webpackChunkName: "RincianTransaksi" */ "@/components/RincianTransaksi.vue"
      ),
    RincianPajak: () =>
      import(
        /* webpackChunkName: "RincianPajak" */ "@/components/RincianPajak.vue"
      )
  },
  data: () => ({
    saving: false,
    loading: false,
    header: {
      Nomor: "",
      Tanggal: new Date().toISOString().substr(0, 10),
      Keterangan: "",
      IDSekolah: "",
      Sekolah: {},
      IDKegiatan: "",
      Kegiatan: {},
      IDProgram: "",
      Program: {},
      IDSP2B: ""
    },
    details: [],
    pajak: [],
    modalDatepicker: false,
    isEditingSekolah: false,
    isEditingKegiatan: false,
    Keyword: "",
    cacheRincianExists: false,
    cachePajakExists: false,
    isEdit: false
  }),
  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", [
      "isSekolahLoading",
      "isKegiatanLoading",
      "isRekeningLoading",
      "isProgramLoading"
    ]),
    isKegiatanEmpty() {
      return this.$util.isEmpty(this.header.Kegiatan);
    },
    isProgramEmpty() {
      return this.$util.isEmpty(this.header.Program);
    },
    isSekolahEmpty() {
      return this.$util.isEmpty(this.header.Sekolah);
    },
    lastUpdatedDatePenerimaan() {
      return this.getLastUpdatedDate("penerimaan");
    },
    lastUpdatedDateBelanja() {
      return this.getLastUpdatedDate("belanja");
    },
    listKegiatan() {
      if (!this.isProgramEmpty) {
        return this.list.kegiatan.data.filter(
          x => x.IDProgram == this.header.IDProgram
        );
      }
      return [];
    },
    totalPenerimaan() {
      return this.getSummary("penerimaan");
    },
    totalBelanja() {
      return this.getSummary("belanja");
    },
    totalPajak() {
      return 0;
    },
    terkunci() {
      return this.header && (!!this.header.ETLID || !!this.header.IDSP2B);
    },
    formattedDate() {
      return this.$format.date(this.header.Tanggal);
    }
  },
  methods: {
    ...mapActions("list", [
      "refreshCurrentProgramKegiatan",
      "refreshSekolah",
      "refreshRekening",
      "refreshPajak"
    ]),
    async save() {
      let param = { ...this.header };

      param.Tanggal = new Date(param.Tanggal);
      param.NominalBelanja = this.getSummary("belanja");
      param.NominalPenerimaan = this.getSummary("penerimaan");
      param.NominalPajak = this.getPajak();
      param.Detail = this.details;
      param.Pajak = this.pajak;

      const valid = await this.$refs.header.validate();
      if (!valid) return;

      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menyimpan data?"
      });
      if (!confirmation) return;

      this.saving = true;
      this.$axios
        .post("/report/transaksi", param)
        .then(res => {
          this.$dialog.notify.success(res.data.Message, {
            ...this.app.notification
          });
          this.clearDetailCache("rincian");
          this.clearDetailCache("pajak");
          this.$router.push("/transaksi");
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            ...this.app.notification
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
    reset() {
      // Object.assign(this.$data, this.$options.data());
      this.$refs.form.reset();
    },
    title() {
      return this.$route.params.id ? "Ubah Transaksi" : "Transaksi Baru";
    },
    getLastUpdatedDate(jenis = "belanja") {
      if (this.details.length == 0) return;

      let result = this.details.filter(x => x.Jenis == jenis);
      if (!result) return;

      result = result.sort((a, b) => {
        let paramA = a.LastUpdatedDate || a.CreatedDate;
        let paramB = b.LastUpdatedDate || b.CreatedDate;

        if (paramA > paramB) return 1;
        return -1;
      })[0];

      if (!result) return;

      return result.LastUpdatedDate || result.CreatedDate;
    },
    getSummary(jenis = "belanja") {
      return _.sumBy(
        this.details.filter(x => x.Jenis == jenis),
        x => x.Nominal
      );
    },
    getPajak() {
      return _.sumBy(this.pajak, x => x.Nominal);
    },
    storeDetailCache(detail, type = "rincian") {
      let key = `transaksi_${type}_cache_${this.header.IDKegiatan}_${this.header.IDSekolah}`;
      if (detail && detail.length > 0) {
        localStorage.setItem(key, JSON.stringify(detail));
      }
    },
    loadDetailCache(type = "rincian") {
      let key = `transaksi_${type}_cache_${this.header.IDKegiatan}_${this.header.IDSekolah}`;
      let cache = localStorage.getItem(key);
      if (cache) {
        try {
          return JSON.parse(cache);
        } catch (error) {
          console.warn("error while parsing cache", key);
          return undefined;
        }
      }
    },
    clearDetailCache(type = "rincian") {
      let key = `transaksi_${type}_cache_${this.header.IDKegiatan}_${this.header.IDSekolah}`;
      localStorage.removeItem(key);
    },
    editKegiatan() {
      this.isEditingKegiatan = true;
    },
    checkEditingStatus() {
      this.isEditingSekolah = this.isSekolahEmpty;
      this.isEditingKegiatan = this.isKegiatanEmpty;
    },
    loadAllCache() {
      this.cacheRincianExists = false;
      this.cachePajakExists = false;
      let details = this.loadDetailCache("rincian");
      if (details) {
        this.details = details;
        this.cacheRincianExists = true;
      } else this.details = [];

      let pajak = this.loadDetailCache("pajak");
      if (pajak) {
        this.pajak = pajak;
        this.cachePajakExists = true;
      } else this.pajak = [];
    },
    async clearAllCache() {
      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda ingin membersihkan cache?"
      });
      if (!confirmation) return;
      this.clearDetailCache("rincian");
      this.clearDetailCache("pajak");
      this.loadAllCache();
    }
  },
  created() {
    this.isEdit = !!this.$route.params.id;
  },
  async mounted() {
    this.refreshPajak();

    let id = this.$route.params.id;
    let user = this.$session.get.user();
    let isUserSekolah = this.$acl.check("isSekolah") && !!user.idSekolah;

    if (!isUserSekolah) this.refreshSekolah();
    if (id) {
      this.loading = true;
      this.$axios
        .get(`/report/transaksi/${id}`)
        .then(res => {
          let result = res.data.Data;

          result.Tanggal = new Date(result.Tanggal).toISOString().substr(0, 10);
          for (let i in result) {
            this.header[i] = result[i];
          }

          this.details = result.Detail.map(x => {
            x.uid = this.$util.uid();
            return x;
          });
          this.pajak = result.Pajak.map(x => {
            x.uid = this.$util.uid();
            return x;
          });
          this.loading = false;
        })
        .catch(error => {
          this.$dialog.notify.error(error, {
            position: this.app.notification.position
          });
        })
        .finally(() => {
          this.checkEditingStatus();
        });
    } else {
      if (isUserSekolah) {
        this.loading = true;
        let filter = new this.$dbflex();
        filter.eq("IDSekolah", user.idSekolah);
        this.$axios
          .post(`/administration/sekolah/list`, { Filter: filter.get() })
          .then(res => {
            let data = res.data.Data;
            if (data && data.length > 0) {
              this.header.IDSekolah = user.idSekolah;
              this.header.Sekolah = data[0];
            }
          })
          .finally(() => {
            this.loading = false;
            this.checkEditingStatus();
          });
      } else {
        this.checkEditingStatus();
      }
    }
  },
  watch: {
    "header.Sekolah"(v) {
      if (!this.$util.isEmpty(v)) {
        this.header.IDSekolah = v.IDSekolah;
        this.refreshCurrentProgramKegiatan({ IDSekolah: v.IDSekolah });
      } else this.header.IDSekolah = "";

      if (!this.$util.isEmpty(v) && !this.isKegiatanEmpty) {
        let id = this.$route.params.id;
        if (!id) this.loadAllCache();

        if (!this.isRekeningLoading) {
          this.refreshRekening({
            type: "rkas",
            param: {
              IDSekolah: this.header.IDSekolah,
              IDKegiatan: this.header.IDKegiatan
            }
          });
        }
      }
    },
    "header.Program"(v) {
      if (!this.$util.isEmpty(v)) {
        this.header.IDProgram = v.IDProgram;
      } else {
        this.header.IDKegiatan = "";
      }
    },
    "header.Kegiatan"(v) {
      if (!this.$util.isEmpty(v)) this.header.IDKegiatan = v.IDKegiatan;
      else this.header.IDKegiatan = "";

      if (!this.$util.isEmpty(v) && !this.isSekolahEmpty) {
        let id = this.$route.params.id;
        if (!id) this.loadAllCache();

        if (!this.isRekeningLoading) {
          this.refreshRekening({
            type: "rkas",
            param: {
              IDSekolah: this.header.IDSekolah,
              IDKegiatan: this.header.IDKegiatan
            }
          });
        }
      }
    },
    "list.sekolah.data"(v) {
      var user = this.$session.get.user();

      if (!this.$util.isEmpty(v) && !user.idSekolah)
        this.header.Sekolah = v.find(s => s.IDSekolah == user.idSekolah);
    },
    "list.program.data"(v) {
      let id = this.$route.params.id;
      if (id) {
        let result = v.find(x => x.IDProgram == this.header.Kegiatan.IDProgram);
        if (result) {
          this.header.IDProgram = result.IDProgram;
          this.header.Program = result;
        }
      }
    },
    details(v, vOld) {
      let id = this.$route.params.id;
      if (!id) {
        // store added details to cache
        if (v && v.length > 0) this.storeDetailCache(v, "rincian");
        if (vOld.length > 0 && v.length == 0) this.clearDetailCache("rincian");
      }
      this.checkEditingStatus();
    },
    pajak(v, vOld) {
      let id = this.$route.params.id;
      if (!id) {
        // store added details to cache
        if (v && v.length > 0) this.storeDetailCache(v, "pajak");
        if (vOld.length > 0 && v.length == 0) this.clearDetailCache("pajak");
      }
      this.checkEditingStatus();
    }
  }
};
</script>

<style>
.card-summary.card-summary--transaksi {
  height: 120px !important;
}
</style>